<template>
    <v-container>
        <!--    Diálogo Persistente para mostrar Errores    -->
        <v-dialog v-model="dialogErrors" persistent width="400">
            <v-card class="justify-center">
                <v-card-title
                        dark
                        class="red display-1 text--primary justify-center"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text class="text-sm-center">
                    <h3>{{errorsGuard}}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialogErrors = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Lista de Estudiantes     -->
        <v-dialog v-model="dialogDeleteList" max-width="600px">
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_list')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogDeleteList = false"
                    >No
                    </v-btn>
                    <v-btn
                            color="primary"
                            :loading="loading"
                            @click="deleteList()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Lista de Estudiantes    -->
        <v-dialog v-model="dialogListStudents" scrollable max-width="500px">
            <v-card :loading="loading" v-if="Object.keys(dataStudents).length > 0" align="center" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('estudiantes')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogListStudents = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text align="center">
                    <v-layout v-if="dataStudents.code_type === 0" align="center" justify="center" row wrap>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12>
                            <h3>Tutor</h3>
                            <br>
                            <v-layout align-center justify-center row wrap>
                                <v-flex xs11>
                                    <v-img
                                            :src="dataStudents.tutor.idFront"
                                            position="center center"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12 v-if="dataStudents.available_students.length > 0">
                            <br>
                            <h3>{{$t('estudiante_s_no_recogido_s')}}</h3>
                            <br>
                            <v-list two-line>
                                <v-list-item v-for="(student, i) in dataStudents.available_students" :key="i" :hidden="student.status === -1">
                                    <v-avatar>
                                        <v-img :src="student.avatar"></v-img>
                                    </v-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title v-text="student.first_name"></v-list-item-title>
                                      <v-list-item-subtitle class="text--primary" v-text="student.last_name"></v-list-item-subtitle>
                                      <v-list-item-subtitle v-text="student.classroom"></v-list-item-subtitle>
                                      <v-list-item-subtitle v-if="student.name_extracurricular_activity">{{$t('workshop')}}: {{student.name_extracurricular_activity}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-btn
                                            medium
                                            color="success"
                                            @click="allowCheckOut(dataStudents.tutor.id, student.id)"
                                    >{{$t('concender_salida')}}
                                    </v-btn>
                                    <v-btn
                                            medium
                                            color="error"
                                            @click="denyCheckOut(dataStudents.tutor.id, student.id)"
                                    >{{$t('denegar_salida')}}
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12 v-if="dataStudents.picked_up_students.length > 0">
                            <br>
                            <h3>{{$t('estudiante_s_recogido_s')}}</h3>
                            <br>
                            <v-list two-line>
                                <v-list-item v-for="(student2, i) in dataStudents.picked_up_students" :key="i" :hidden="student2.status === -1">
                                    <v-avatar>
                                        <v-img :src="student2.avatar"></v-img>
                                    </v-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title v-text="student2.first_name"></v-list-item-title>
                                      <v-list-item-subtitle class="text--primary" v-text="student2.last_name"></v-list-item-subtitle>
                                      <v-list-item-subtitle v-text="student2.classroom"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="dataStudents.code_type === 1" align="center" justify="center" row wrap>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12>
                            <h3>{{$t('invitado')}}</h3>
                            <br>
                            <v-layout align-center justify-center row wrap>
                                <v-flex xs11>
                                    <v-img
                                            :src="dataStudents.invitation.invited_tutor.idFront"
                                            position="center center"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12 v-if="dataStudents.available_students.length > 0">
                            <br>
                            <h3>{{$t('estudiante_s_no_recogido_s')}}</h3>
                            <br>
                            <v-list two-line>
                                <v-list-item v-for="(student, i) in dataStudents.available_students" :key="i" :hidden="student.status === -1">
                                    <v-avatar>
                                        <v-img :src="student.avatar"></v-img>
                                    </v-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title v-text="student.first_name"></v-list-item-title>
                                      <v-list-item-subtitle class="text--primary" v-text="student.last_name"></v-list-item-subtitle>
                                      <v-list-item-subtitle v-text="student.classroom"></v-list-item-subtitle>
                                      <v-list-item-subtitle v-if="student.name_extracurricular_activity">{{$t('workshop')}}: {{student.name_extracurricular_activity}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-btn
                                            medium
                                            color="success"
                                            @click="allowCheckOut(dataStudents.invitation.invited_tutor.id, student.id)"
                                    >{{$t('concender_salida')}}
                                    </v-btn>
                                    <v-btn
                                            medium
                                            color="error"
                                            @click="denyCheckOut(dataStudents.invitation.invited_tutor.id, student.id)"
                                    >{{$t('denegar_salida')}}
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12 v-if="dataStudents.picked_up_students.length > 0">
                            <br>
                            <h3>{{$t('estudiante_s_recogido_s')}}</h3>
                            <br>
                            <v-list two-line>
                                <v-list-item v-for="(student2, i) in dataStudents.picked_up_students" :key="i" :hidden="student2.status === -1">
                                    <v-avatar>
                                        <v-img :src="student2.avatar"></v-img>
                                    </v-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title v-text="student2.first_name"></v-list-item-title>
                                      <v-list-item-subtitle class="text--primary" v-text="student2.last_name"></v-list-item-subtitle>
                                      <v-list-item-subtitle v-text="student2.classroom"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
        <h2>{{$t('list_students')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-card width="600">
                <v-toolbar class="mb-5" dark color="primary">
                    <v-toolbar-title>
                        {{$t('list_students')}}
                    </v-toolbar-title>
                    <template v-if="studentsList.length !== 0" v-slot:extension>
                        <v-btn
                                fab
                                color="red"
                                bottom
                                left
                                absolute
                                @click="dialogDeleteList = true"
                        >
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </v-toolbar>
                <v-card-text>
                    <div v-if="studentsList.length !== 0">
                        <v-list two-line v-for="(student, i) in studentsList" :key="i">
                            <div v-if="student.code_type === 0">
                              <v-list two-line>
                                <v-list-item-group>
                                  <template v-for="(item, index) in student.available_students">
                                    <v-list-item v-bind:key="index" v-if="student.available_students.length > 0" :hidden="item.status === -1">
                                        <v-icon
                                                large
                                                color="primary"
                                                class="mr-2"
                                                @click="printListStudents(student)"
                                        >
                                            mdi-magnify
                                        </v-icon>
                                        <v-avatar>
                                          <v-img :src="item.avatar"></v-img>
                                        </v-avatar>
                                        <v-list-item-content>
                                          <v-list-item-title v-text="item.first_name"></v-list-item-title>
                                          <v-list-item-subtitle class="text--primary" v-text="item.last_name"></v-list-item-subtitle>
                                          <v-list-item-subtitle v-text="item.classroom"></v-list-item-subtitle>
                                          <v-list-item-subtitle v-if="item.name_extracurricular_activity">{{$t('workshop')}}: {{item.name_extracurricular_activity}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                          <v-btn
                                                  medium
                                                  color="success"
                                                  @click="allowCheckOut(student.tutor.id, item.id)"
                                          >{{$t('concender_salida')}}
                                          </v-btn>
                                          <v-btn
                                                  medium
                                                  color="error"
                                                  @click="denyCheckOut(student.tutor.id, item.id)"
                                          >{{$t('denegar_salida')}}
                                          </v-btn>
                                    </v-list-item>
                                    <v-divider
                                      v-if="index < student.available_students.length - 1"
                                      :key="index"
                                    ></v-divider>
                                  </template>
                                </v-list-item-group>
                              </v-list>
                            </div>
                            <div v-if="student.code_type === 1">
                              <v-list two-line>
                                <v-list-item-group>
                                  <template v-for="(item, index) in student.available_students">
                                    <v-list-item v-bind:key="index" v-if="student.available_students.length > 0" :hidden="item.status === -1">
                                        <v-icon
                                                large
                                                color="primary"
                                                class="mr-2"
                                                @click="printListStudents(student)"
                                        >
                                            mdi-magnify
                                        </v-icon>
                                        <v-avatar>
                                          <v-img :src="item.avatar"></v-img>
                                        </v-avatar>
                                        <v-list-item-content>
                                          <v-list-item-title v-text="item.first_name"></v-list-item-title>
                                          <v-list-item-subtitle class="text--primary" v-text="item.last_name"></v-list-item-subtitle>
                                          <v-list-item-subtitle v-text="item.classroom"></v-list-item-subtitle>
                                        </v-list-item-content>
                                          <v-btn
                                                  medium
                                                  color="success"
                                                  @click="allowCheckOut(student.invitation.invited_tutor.id, item.id)"
                                          >{{$t('concender_salida')}}
                                          </v-btn>
                                          <v-btn
                                                  medium
                                                  color="error"
                                                  @click="denyCheckOut(student.invitation.invited_tutor.id, item.id)"
                                          >{{$t('denegar_salida')}}
                                          </v-btn>
                                    </v-list-item>
                                    <v-divider
                                      v-if="index < student.available_students.length - 1"
                                      :key="index"
                                    ></v-divider>
                                  </template>
                                </v-list-item-group>
                              </v-list>
                            </div>
                        </v-list>
                    </div>
                    <div v-else>
                        <h2>{{$t('sin_registros')}}</h2>
                    </div>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import { mapState } from 'vuex'


export default {
  name: "guard_list",
  data () {
    return {
      dialogListStudents: false,
      loading: false,
      dataStudents: [],
      dialogDeleteList: false,
      dialogErrors: false,
      errorsGuard: '',
    }
  },
  computed: {
    ...mapState(['studentsList'])
  },

  created () {
    if(localStorage.getItem('listaEstudiantes') !== null) {
      this.studentsList = JSON.parse(localStorage.getItem('listaEstudiantes'))
      console.log(this.studentsList)
    }
  },
  methods: {
    printListStudents(item) {
      this.dataStudents = item
      console.log(this.dataStudents)
      this.dialogListStudents = true
    },
    deleteList () {
      this.loading = true
      HTTP.delete('checkout_list/delete/' + localStorage.getItem('idGuardHouse') + '/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        localStorage.removeItem('listaEstudiantes')
        this.studentsList = []
        this.$socket.send(JSON.stringify( {
          "message":  JSON.stringify('addRecord')
        }))
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('list_delete_success'))
        setTimeout(this.clear, 3000)
        this.loading = false
        this.dialogDeleteList = false
      })
      .catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    updateDataStudent(qrCode, uuidStudent) {
      let band = false
      let index = -1

      for(let i = 0 ; !band && i < this.studentsList.length; i++) {
        console.log(this.studentsList[i].qrCode, '===', qrCode)
        if(this.studentsList[i].qrCode === qrCode){
          band = true
          index = i
        }
      }
      if (band === true) {
        band = false
        let index2 = -1
        for(let i = 0 ; !band && i < this.studentsList[index].available_students.length; i++) {
          console.log(this.studentsList[index].available_students[i].id, '===', uuidStudent)
          if(this.studentsList[index].available_students[i].id === uuidStudent){
            band = true
            index2 = i
          }
        }
        if(band === true) {
          let alumnoAux = this.studentsList[index].available_students[index2]
          console.log('Ver si realmente se vacia lista alumnos dipsonibles Tam = ', this.studentsList[index].available_students.length)
          // delete this.studentsList[index].available_students[index2]
          this.studentsList[index].available_students.splice(index2, 1)
          console.log('Ver si realmente se vacia lista alumnos dipsonibles Tam = ', this.studentsList[index].available_students.length)

          if (this.studentsList[index].available_students.length === 0) {
            this.studentsList.splice(index, 1)
          } else {
            this.studentsList[index].picked_up_students.push(alumnoAux)
          }
          localStorage.setItem('listaEstudiantes',  JSON.stringify(this.studentsList))
          this.$socket.send(JSON.stringify( {
            "message": JSON.stringify(this.studentsList)
          }))
        }
      }
    },
    allowCheckOut(uuidTutor, uuidStudent) {
      this.loading = true
      HTTP.post('exit/validate/' + uuidStudent, {
        idTutor: uuidTutor
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.loading = false
        this.$socket.send(JSON.stringify( {
          "message":  JSON.stringify('addRecord')
        }))
        // this.updateDataStudent(qrCode, uuidStudent)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('msg_alta_salida'))
        setTimeout(this.clear, 3000)
        console.log(response)
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 403) {
          this.errorsGuard = this.$t('msg_student_exit_pass_disable')
          this.dialogErrors = true
        }
        console.log(error.response.data)
      })
    },
    denyCheckOut(uuidTutor, uuidStudent) {
      this.loading = true
      HTTP.post('exit/invalidate/' + uuidStudent, {
        idTutor: uuidTutor
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.loading = false
        // this.updateDataStudent(qrCode, uuidStudent)
        this.$socket.send(JSON.stringify( {
          "message":  JSON.stringify('addRecord')
        }))
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('msg_alta_salida'))
        setTimeout(this.clear, 3000)
        console.log(response)
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 403) {
          this.errorsGuard = this.$t('msg_student_exit_pass_disable')
          this.dialogErrors = true
        }
        console.log(error.response.data)
      })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>
.scroll {
   overflow-y: scroll
}
</style>
